import React, { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { OptionCard } from 'components/OptionCard'
import {
  TERMS_LINKS_GROUP_VARIANT,
  TermsLinksGroup,
} from 'components/TermsLinksGroup'

import { useDelayedContinue } from 'hooks/useDelayedContinue'
import { useDynamicTextsFromUrl } from 'hooks/useDynamicTextsFromUrl'
import { useNextStep } from 'hooks/useNextStep'

import { TPageProps } from 'models/common.model'

import { CustomPageId, PageId } from 'page-constants'
import { Color, Language, OptionType } from 'root-constants'

import { StyledAyahGender as S } from './AyahGender.styles'
import { AYAH_GENDER_OPTIONS } from './constants'

export const AyahGender: React.FC<TPageProps> = ({
  pageId,
  nextPagePath,
  isFirstPage,
}) => {
  const { t } = useTranslation()
  const { firstPageTitle, firstPageSubtitle } = useDynamicTextsFromUrl()
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const [answer, setAnswer] = useState<string>('')

  const questionText =
    firstPageTitle ||
    t('onboarding.selectGenderAyah.title', {
      lng: Language.EN,
    })

  const handleContinue = useNextStep({
    pageId: CustomPageId.GENDER,
    question: questionText,
    nextPagePath,
    isFirstPage: pageId === PageId.AYAH_GENDER || isFirstPage,
  })

  const handleAnswerChange = (value: string) => {
    handleChange(value, handleContinue)
    setIsAnswersDisabled(true)
    setAnswer(value)
  }

  return (
    <S.Container>
      <S.Header>
        <S.Title>
          {firstPageTitle || (
            <Trans i18nKey="onboarding.selectGenderAyah.title" />
          )}
        </S.Title>
        <S.Subtitle>
          {firstPageSubtitle || (
            <Trans i18nKey="onboarding.selectGenderAyah.subtitle" />
          )}
        </S.Subtitle>
      </S.Header>

      <S.CardsContainer>
        {AYAH_GENDER_OPTIONS.map(({ value, text, imageUrl }) => (
          <OptionCard
            key={value}
            imageUrl={imageUrl}
            value={value}
            label={t(text)}
            checked={answer === value}
            disabled={isAnswersDisabled}
            $backgroundColor={Color.SKY_DARK}
            $minHeight="268px"
            $renderImageAsImg
            name={pageId}
            type={OptionType.RADIO}
            onChange={handleAnswerChange}
          />
        ))}
      </S.CardsContainer>

      <S.Terms>
        <TermsLinksGroup
          titleKey="commonComponents.termsGenderTitle"
          variant={TERMS_LINKS_GROUP_VARIANT.DARK}
        />

        <S.TermsNote>{t('commonComponents.termsNote')}</S.TermsNote>
      </S.Terms>
    </S.Container>
  )
}
